"use strict";
/* globals module */
/**
 * @module calendarACLRoute
 * @description Baasic Calendar ACL Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Calendar ACL Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
;
var contracts_1 = require("../../../core/contracts");
var CalendarACLRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarACLRoute, _super);
    function CalendarACLRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'calendars/{id}/acl';
        _this.updateRoute = 'calendars/{id}/acl';
        _this.deleteByUserRoute = 'calendars/{id}/acl/actions/{accessAction}/users/{userName}';
        _this.deleteByRoleRoute = 'calendars/{id}/acl/actions/{accessAction}/roles/{role}';
        return _this;
    }
    /**
     * Parses get calendar acl route; this URI template should be expanded with the Id of the calnedar.
     * @method
     * @param options ACL options object.
     * @example calendarACLRoute.get({id: '<id>'});
     */
    CalendarACLRoute.prototype.get = function (options) {
        var params = this.utility.extend({}, options);
        return _super.prototype.baseCreate.call(this, this.getRoute, params);
    };
    /**
     * Parses update calendar acl route; this URI template should be expanded with the Id of the calnedar.
     * @method
     * @param options ACL options object.
     * @example calendarACLRoute.update({id: '<id>'});
     */
    CalendarACLRoute.prototype.update = function (options) {
        var params = this.utility.extend({}, options);
        return _super.prototype.baseCreate.call(this, this.updateRoute, params);
    };
    /**
     * Parses deleteByUser calendar acl route which can be expanded with additional options. Supported items are:
     * - `id` - Id of the user calnedar data resource.
     * - `accessAction` - Action abbreviation which identifies ACL policy assigned to the specified user and calendar resource.
     * - `user` - A value which uniquely identifies user for which ACL policy needs to be removed.
     * @method
     * @param id user calnedar data id which uniquely identifies user calnedar data resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and user calnedar data resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param user A value that uniquely identifies user for which ACL policy needs to be removed.
     * @param data ACL Policy object used to delete specified item in the system.
     * @example calendarACLRoute.deleteByUser({
                    id: '<id>',
                    accessAction: '<access-action>',
                    user: '<username>'
                });
     */
    CalendarACLRoute.prototype.deleteByUser = function (id, action, user, data) {
        var params = this.modelMapper.removeParams(data);
        params.id = id;
        params.userName = user;
        params.accessAction = action;
        return _super.prototype.baseCreate.call(this, this.deleteByUserRoute, params);
    };
    /**
     * Parses deleteByUser calendar acl route which can be expanded with additional options. Supported items are:
     * - `id` - Id of the calendar.
     * - `accessAction` - Action abbreviation which identifies ACL policy assigned to the specified role and calendar resource.
     * - `role` - A value which uniquely identifies role for which ACL policy needs to be removed.
     * @method
     * @param id User calendar data id which uniquely identifies user calendar data resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and user calendar data resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param role A value that uniquely identifies role for which ACL policy needs to be removed.
     * @param data ACL Policy object used to delete specified item in the system.
     * @example calendarACLRoute.deleteByRole({ id: '<id>', accessAction: '<access-action>', role: '<role-name>'});
     */
    CalendarACLRoute.prototype.deleteByRole = function (id, action, role, data) {
        var params = this.modelMapper.removeParams(data);
        params.id = id;
        params.role = role;
        params.accessAction = action;
        return _super.prototype.baseCreate.call(this, this.deleteByRoleRoute, params);
    };
    CalendarACLRoute.prototype.updateParams = function (data) {
        var params = this.utility.extend({}, data);
        return params[this.modelMapper.modelPropertyName];
    };
    var _a;
    CalendarACLRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarACLRoute);
    return CalendarACLRoute;
}(common_1.BaseRoute));
exports.CalendarACLRoute = CalendarACLRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
  - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
  - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
  - All end-point objects are transformed by the associated route service.
 */ 
